<section class="home-hero">
  <div class="container">
    <div class="info-box">
      <div class="d-flex align-items-center justify-content-center flex-wrap gap-3">
        <span class="pill">Official Federal Portal</span>
        <span class="pill bg-success">CAMA 2020 Compliant</span>
      </div>
      <h1 class="title">Nigeria's Beneficial Ownership Register (BOR)</h1>
      <p class="description">Promoting corporate transparency and national security. Search and retrieve verified Persons with Significant Control (PSC) across all registered corporate entities in Nigeria.</p>
    </div>

    <div class="search-box">
      <div class="input-group" [ngClass]="{'error': hasError}">
        <span class="input-group-text"><iconify [name]="'lucide:search'" /></span>
        <input
          [(ngModel)]="searchTerm"
          (ngModelChange)="hasError = false;"
          (keydown.enter)="onSearch()"
          class="form-control"
          placeholder="Search by company name, RC number, or PSC name..."
        />
      </div>
      <button class="btn btn-primary align-self-stretch" (click)="onSearch()">Search Registry</button>
    </div>
  </div>
</section>

<bor-about-section />

<section class="operation-line-section section-padding vw-100 overflow-hidden">
  <div class="container container-max">
    <span class="section-subtitle-pill bg-2">Operational Pipeline</span>
    <h2 class="heading-color-1 section-title mt-2 mb-3">Three Steps to Compliance & Discovery</h2>
    <p class="pb-4">Providing unhindered, standard-based pathways to beneficial ownership records.</p>

    <ul class="list-unstyled row g-4">
      <li class="col-md-6 col-lg-4">
        <div class="card p-4">
          <div class="step-info mb-4">
            <div class="step-icon-wrapper"><iconify [name]="'lucide:search'" /></div>
            <p class="number">01</p>
          </div>
          <h3 class="heading-font heading-color-2 fs-20 mb-2">Query Entity</h3>
          <p class="fs-14 line-height-150p">Perform a search by typing in the business entity name or registered RC number into the secure registry dashboard.</p>
        </div>
      </li>
      <li class="col-md-6 col-lg-4">
        <div class="card p-4">
          <div class="step-info mb-4">
            <div class="step-icon-wrapper"><iconify [name]="'lucide:user'" /></div>
            <p class="number">02</p>
          </div>
          <h3 class="heading-font heading-color-2 fs-20 mb-2">Verify PSC Structure</h3>
          <p class="fs-14 line-height-150p">Review real-time visualized charts of beneficial ownership, detailing voting power and percent share holding.</p>
        </div>
      </li>
      <li class="col-lg-4">
        <div class="card p-4">
          <div class="step-info mb-4">
            <div class="step-icon-wrapper"><iconify [name]="'lucide:download'" /></div>
            <p class="number">03</p>
          </div>
          <h3 class="heading-font heading-color-2 fs-20 mb-2">Export Data Stream</h3>
          <p class="fs-14 line-height-150p">Download secure, machine-readable datasets formatted precisely in BODS-JSON schemas for downstream integration.</p>
        </div>
      </li>
    </ul>
  </div>
</section>

<section class="definition-matrix-section section-padding vw-100 overflow-hidden">
  <div class="container">
    <span class="section-subtitle-pill bg-3">Definition Matrix</span>
    <h2 class="heading-color-1 section-title mt-2 mb-3">Who qualifies as a Person with Significant Control?</h2>
    <p class="fs-15 pb-4">A Person with Significant Control (PSC) is defined under CAMA 2020 by meeting any of these four criteria.</p>

    <ul class="list-unstyled row g-4">
      <li class="col-md-6">
        <div class="card-item">
          <span class="icon-wrapper"><iconify [name]="'lucide:pie-chart'" /></span>
          <div class="flex-grow-1">
            <h3 class="fs-18 fw-semibold heading-font heading-color-1 mb-2">5% Direct or Indirect Shares</h3>
            <p class="fs-14 line-height-150p">Holding at least 5% of the issued shares or interest in the registered corporate entity directly or through a nominee.</p>
          </div>
        </div>
      </li>
      <li class="col-md-6">
        <div class="card-item">
          <span class="icon-wrapper variant-2"><iconify [name]="'lucide:percent'" /></span>
          <div class="flex-grow-1">
            <h3 class="fs-18 fw-semibold heading-font heading-color-1 mb-2">5% Voting Rights Allocation</h3>
            <p class="fs-14 line-height-150p">Controlling at least 5% of the voting rights in the company, allowing direct influence over general corporate assembly votes.</p>
          </div>
        </div>
      </li>
      <li class="col-md-6">
        <div class="card-item">
          <span class="icon-wrapper variant-3"><iconify [name]="'lucide:users'" /></span>
          <div class="flex-grow-1">
            <h3 class="fs-18 fw-semibold heading-font heading-color-1 mb-2">Director Appointment Powers</h3>
            <p class="fs-14 line-height-150p">Possessing the legal power to appoint, remove, or influence the majority of board members or operational directors.</p>
          </div>
        </div>
      </li>
      <li class="col-md-6">
        <div class="card-item">
          <span class="icon-wrapper variant-4"><iconify [name]="'lucide:activity'" /></span>
          <div class="flex-grow-1">
            <h3 class="fs-18 fw-semibold heading-font heading-color-1 mb-2">Significant Direct Control</h3>
            <p class="fs-14 line-height-150p">Exercising significant influence or control over the operational policies, structures, or legal decisions of the business entity.</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</section>

<bor-global-standards-section />

<bor-faq-section />

<bor-contacts-section />

